import { motion } from "framer-motion";
import { Rewind, Bookmark, Calendar } from "lucide-react";

const CloudDVR = () => (
  <section id="dvr" data-testid="dvr-section" className="relative py-12 md:py-14">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#22D3EE] font-semibold mb-4">
            Cloud DVR
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-extrabold leading-tight">
            Never miss your
            <br />
            <span className="gradient-text">favourite live programs.</span>
          </h2>
          <p className="mt-5 text-white/65 text-lg max-w-lg">
            Record supported live channels, save programs, and watch later when
            your schedule allows. Up to 3 days back, on any device.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href="#features" className="rounded-full bg-white/5 border border-white/15 text-white/90 px-6 py-3 text-sm font-medium hover:bg-white/10 transition-colors">
              What&apos;s included
            </a>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-6"
        >
          <div
            className="relative rounded-3xl border border-[#22D3EE]/25 bg-[#0F0A19] p-6 md:p-8 overflow-hidden"
            style={{ boxShadow: "0 0 0 1px rgba(34,211,238,0.10), 0 20px 60px -20px rgba(34,211,238,0.25)" }}
          >
            <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-gradient-to-br from-[#6B21D9]/25 to-[#22D3EE]/15 blur-3xl" />
            <div className="relative flex flex-col gap-4">
              <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 p-4">
                <div className="w-10 h-10 rounded-full bg-red-500/15 border border-red-500/30 flex items-center justify-center">
                  <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-red-300">Recording</div>
                  <div className="text-white font-semibold">Evening News · Live</div>
                </div>
                <span className="text-xs text-white/50">Saved to DVR</span>
              </div>
              <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 p-4">
                <div className="w-10 h-10 rounded-full bg-[#6B21D9]/25 border border-[#6B21D9]/40 flex items-center justify-center">
                  <Bookmark className="w-4 h-4 text-[#c4b5fd]" />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-[#c4b5fd]">Saved</div>
                  <div className="text-white font-semibold">Weekend Cricket · Highlights</div>
                </div>
                <span className="text-xs text-white/50">2h 15m</span>
              </div>
              <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 p-4">
                <div className="w-10 h-10 rounded-full bg-[#22D3EE]/20 border border-[#22D3EE]/40 flex items-center justify-center">
                  <Calendar className="w-4 h-4 text-[#67e8f9]" />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-[#67e8f9]">EPG</div>
                  <div className="text-white font-semibold">Prime-time drama · Tonight 8:00</div>
                </div>
                <Rewind className="w-4 h-4 text-white/40" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default CloudDVR;
